import request from 'utils/request'

/**
 * 获取审批历史记录列表
 * @param {*} data
 */
export const getRecordList = data => request().post('bp/approve/pageMine', data)

export const getBatchRecordList = data =>
  request().post('bp/batch/approve/page', data)

export const exportRecord = data =>
  request().post('bp/batch/approve/export', data, {
    responseType: 'arraybuffer',
  })

export const exportList = data =>
  request().post('bp/approve/export', data, {
    responseType: 'arraybuffer',
  })

/**
 * 获取自动审批历史记录列表
 * @param {*} data
 */
export const getAutoRecordList = data =>
  request().post('bp/approveAutomatic/pageMine', data)

/**
 * 获取账期调整审批记录列表
 * @param {*} data
 */
export const getApproveRecordList = data =>
  request().post('bp/approveTremRecordList/page', data)

/**
 * 获取延期审批历史记录列表
 * @param {*} data
 */
export const getExtensionRecordList = data =>
  request().post('limit/approve/pageMine', data)

export const extensionExportList = data =>
  request().post('limit/approve/export', data, {
    responseType: 'arraybuffer',
  })

export const getBatchExtensionRecordList = data =>
  request().post('limit/batch/approve/page', data)

export const extensionExportRecord = data =>
  request().post('limit/batch/approve/export', data, {
    responseType: 'arraybuffer',
  })
